import { FC } from 'react';
import AlfredDetailTemplate from 'components/template/AlfredDetailTemplate';
import TabsAtom from 'components/atoms/TabsAtom';
import { useGatewayDetail } from './resources/useGatewayDetail';
import { GatewayDetailTabType } from './utils';
import TabInfo from './tabs/info';

const GatewayDetailPage: FC = () => {
  const {
    gatewayId,
    tabId,
    title,
    tabItemList,
  } = useGatewayDetail();

  return (
    <AlfredDetailTemplate
      currentTabKey={tabId}
      key={gatewayId}
      title={title}
      loading={false}
      extra={[]}
      description={<></>}
      tabsTitles={(currentTab) => <TabsAtom activeKey={currentTab} items={tabItemList} />}
    >
      {[
        { key: GatewayDetailTabType.INFO, render: <TabInfo key={GatewayDetailTabType.INFO} /> },
      ]}
    </AlfredDetailTemplate>
  );
};

export default GatewayDetailPage;
